import { render, staticRenderFns } from "./FundBasicHk.vue?vue&type=template&id=8fe28b62&scoped=true"
import script from "./FundBasicHk.vue?vue&type=script&lang=js"
export * from "./FundBasicHk.vue?vue&type=script&lang=js"
import style0 from "./FundBasicHk.vue?vue&type=style&index=0&id=8fe28b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe28b62",
  null
  
)

export default component.exports